import { Component, Input, Output, OnInit, ViewChild, ElementRef, HostListener, EventEmitter } from '@angular/core';
import { GameSetUpService } from '../../providers/gameSetUp.service';


@Component({
    selector: 'game-component',
    templateUrl: './game.component.html',
    styleUrls: ['./game.component.scss']
})
export class GameComponent implements OnInit {

    @Input() gameData: any = null;

    @Output() quit = new EventEmitter();
    @Output() restored = new EventEmitter();

    public currentTeam: number = 0;
    public currentSet: number = 0;
    public currentLeg: number = 0;
    public currentCountUpRound: number = 0;
    public editMode: boolean = false;
    public editScoreValue: number = null;

    public legBeginner: number = 0;
    public setBeginner: number = 0;

    public showWinner: boolean = false;
    // public winType: string = null;
    public winnerData: any = {
        leg: null,
        set: null,
        setEnd: false,
        end: false,
    };

    public isPadBlocked: boolean = false;

    public editScoreMode: boolean = false;
    public editScoreData: any = null;


    public showQuitGameModal: boolean = false;

    @Input() teams: any = [
        {
            name: 'Player 1',
            id: 0,
            sets: [
                {
                    legs: [
                        {
                            win: false,
                            scores: [12, 23, 80, 36, 29, 50, 20, 2, 9, 10, 22, 92]
                        }
                    ]
                }
            ]
        },
        {
            name: 'Player 2',
            id: 1,
            sets: [
                {
                    legs: [
                        {
                            win: false,
                            scores: [29, 50, 20, 2, 9, 10, 22, 12, 23, 39, 20, 10]
                        }
                    ]
                }
            ]
        },
        {
            name: 'Player 3',
            id: 2,
            sets: [
                {
                    legs: [
                        {
                            win: false,
                            scores: [10, 50, 20, 45, 66, 53, 21, 72, 22, 92, 15, 39]
                        }
                    ]
                }
            ]
        },
        {
            name: 'Player 4',
            id: 3,
            sets: [
                {
                    legs: [
                        {
                            win: false,
                            scores: [20, 10, 45, 29, 50, 20, 2, 9, 10, 22, 66, 53]
                        }
                    ]
                }
            ]
        }
    ];
    @Output() teamsChange = new EventEmitter();

    public gameReady: boolean = false;
    public hideGoodDarts: boolean = false;


    constructor(public gameSetUpService: GameSetUpService) {
    }


    ngOnInit() {

        setTimeout(_ => this.gameReady = true);

        setTimeout(() => {
            this.hideGoodDarts = true;
        }, 2000);

        if (this.gameData != null) {
            this.restoreGame(this.gameData);
        }

        this.saveGame();


    }


    ngOnChanges() {
        console.log('GAME ON CHANGES');

        if (this.gameReady) {
            this.saveGame();
        }

    }


    getCurrentGame() {
        return JSON.parse(localStorage.getItem('currentGame'));
    }


    restoreGame(data) {
        console.log(data);
        this.currentTeam = data.gameData.currentTeam;
        this.currentSet = data.gameData.currentSet;
        this.currentLeg = data.gameData.currentLeg;
        this.currentCountUpRound = data.gameData.currentCountUpRound;
        this.legBeginner = data.gameData.legBeginner;
        this.setBeginner = data.gameData.setBeginner;
        this.teams = data.gameData.teams;
        setTimeout(_ => this.teamsChange.emit(data.gameData.teams));

        this.winnerData = data.gameData.winnerData;
        this.showWinner = data.gameData.showWinner;


        this.gameSetUpService.gameMode = data.setUpData.gameMode;
        this.gameSetUpService.points = data.setUpData.points;
        this.gameSetUpService.sets = data.setUpData.sets;
        this.gameSetUpService.legs = data.setUpData.legs;
        this.gameSetUpService.throws = data.setUpData.throws;
        this.gameSetUpService.countUpRounds = data.setUpData.countUpRounds;
        this.gameSetUpService.teamCount = data.setUpData.teamCount;
    }


    saveGame() {
        localStorage.setItem('currentGame', JSON.stringify(
            {
                gameData: {
                    currentTeam: this.currentTeam,
                    currentSet: this.currentSet,
                    currentLeg: this.currentLeg,
                    currentCountUpRound: this.currentCountUpRound,
                    legBeginner: this.legBeginner,
                    setBeginner: this.setBeginner,
                    teams: this.teams,

                    showWinner: this.showWinner,
                    winnerData: this.winnerData
                },
                setUpData: {
                    gameMode: this.gameSetUpService.gameMode,
                    points: this.gameSetUpService.points,
                    sets: this.gameSetUpService.sets,
                    legs: this.gameSetUpService.legs,
                    throws: this.gameSetUpService.throws,
                    countUpRounds: this.gameSetUpService.countUpRounds,
                    teamCount: this.gameSetUpService.teamCount
                }
            }
        ));
        console.log('GAME SAVED', this);
    }


    getTeamData(index) {
        return {
            name: this.teams[index].name,
            id: this.teams[index].id,
            scores: this.teams[index].sets[this.currentSet].legs[this.currentLeg].scores,
            points: this.gameSetUpService.points + this.teams[index].handicap,
            finishing: this.teams[index].finishing
        };
    }


    resetGame() {
        this.currentTeam = 0;
        this.currentSet = 0;
        this.currentLeg = 0;
        this.currentCountUpRound = 0;
        this.editMode = false;
        this.editScoreValue = null;

        this.legBeginner = 0;
        this.setBeginner = 0;

        this.teams = [];
        setTimeout(_ => this.teamsChange.emit(this.teams));
    }

    onReplay() {
        this.currentTeam = 0;
        this.currentSet = 0;
        this.currentLeg = 0;
        this.currentCountUpRound = 0;
        this.editMode = false;
        this.editScoreValue = null;

        this.legBeginner = 0;
        this.setBeginner = 0;

        this.resetTeamsData();

        this.showWinner = false;
    }

    resetTeamsData() {
        for (let teamIndex = 0; teamIndex < this.teams.length; teamIndex++) {
            let legs = this.teams[teamIndex].sets[0].legs;
            for (let legIndex = 0; legIndex < legs.length; legIndex++) {
                legs[legIndex].win = false;
                legs[legIndex].scores = [];
            }
        }
    }


    openQuitGameModal() {
        this.showQuitGameModal = true;
    }

    quitGame() {
        localStorage.removeItem('currentGame');
        this.resetGame();
        this.showQuitGameModal = false;
        this.quit.emit();
    }


    onPadValueChange(event) {

        if (!this.isScoreToHigh(event)) {
            this.teams[this.currentTeam].sets[this.currentSet].legs[this.currentLeg].scores.unshift(event);
            if (this.checkIfTeamHasWon(this.currentTeam)) {
                console.log(this.teams[this.currentTeam].name + ' has won!');

                this.setWinner();
                this.nextLeg();

            } else {
                this.nextTeam();
            }
        } else {
            this.teams[this.currentTeam].sets[this.currentSet].legs[this.currentLeg].scores.unshift(null);
            this.nextTeam();
        }

        if (this.editMode) {
            this.editMode = false;
        }

        this.saveGame();

    }



    onPadEditValueChange(event) {

        let realCurrentTeam = this.currentTeam;

        this.currentTeam = this.editScoreData.teamData.id;
        this.editScoreData.teamData.scores[this.editScoreData.scoreIndex] = 0;

        if (!this.isScoreToHigh(event)) {
            this.editScoreData.teamData.scores[this.editScoreData.scoreIndex] = event;

            if (this.checkIfTeamHasWon(this.currentTeam)) {
                console.log(this.teams[this.currentTeam].name + ' has won!');

                this.setWinner();
                if (this.gameSetUpService.gameMode === 'X01') {
                    this.nextLeg();
                }

            }
        } else {
            this.editScoreData.teamData.scores[this.editScoreData.scoreIndex] = null;
            // this.teams[this.currentTeam].sets[this.currentSet].legs[this.currentLeg].scores.unshift(null);
        }

        this.currentTeam = realCurrentTeam;

        this.editScoreMode = false;
        this.saveGame();
    }




    isScoreToHigh(score) {
        let isToHigh = false;
        let sum = this.teams[this.currentTeam].sets[this.currentSet].legs[this.currentLeg].scores.reduce(function(pv, cv) { return pv + cv; }, 0);


        console.log('score', score);
        if ((this.gameSetUpService.points + this.teams[this.currentTeam].handicap) - sum < score) {
            isToHigh = true;
        }

        if((this.gameSetUpService.points + this.teams[this.currentTeam].handicap - sum - score == 1 && this.teams[this.currentTeam].finishing == 'doubleOut')){
            isToHigh = true;
        }

        if (this.gameSetUpService.gameMode === 'count-up') {
            isToHigh = false;
        }

        return isToHigh;
    }


    nextTeam() {
        this.isPadBlocked = true;
        setTimeout(() => {
            if (this.currentTeam < this.gameSetUpService.teamCount - 1) {
                this.currentTeam++;
            } else {
                this.currentTeam = 0;

                if (this.gameSetUpService.gameMode === 'count-up') {
                    this.currentCountUpRound++;
                }
            }

            this.saveGame();
            this.isPadBlocked = false;
        }, 1500);
    }


    nextLegBeginner() {
        if (this.legBeginner < this.gameSetUpService.teamCount - 1) {
            this.legBeginner++;
        } else {
            this.legBeginner = 0;
        }
        this.currentTeam = this.legBeginner;
    }


    /* previousLegBeginner() {
        if (this.legBeginner > 0) {
            this.legBeginner--;
        } else {
            this.legBeginner = this.gameSetUpService.teamCount - 1;
        }

        for (let i = 0; i < this.teams.length; i++) {
            if (this.teams[i].sets[this.currentSet].legs[this.currentLeg].win) {
                this.teams[i].sets[this.currentSet].legs[this.currentLeg].win = false;
                this.currentTeam = i;
            }
        }
        // this.currentTeam = this.legBeginner;
    } */


    /* nextSetBeginner() {
        if (this.setBeginner < this.gameSetUpService.teamCount - 1) {
            this.setBeginner++;
        } else {
            this.setBeginner = 0;
        }
        this.legBeginner = this.setBeginner;
        this.currentTeam = this.setBeginner;
    } */


    /* previousSetBeginner() {
        if (this.setBeginner > 0) {
            this.setBeginner--;
        } else {
            this.setBeginner = this.gameSetUpService.teamCount - 1;
        }



        // this.currentTeam = this.setBeginner;
        this.currentLeg = this.gameSetUpService.legs - 1;

        let legBeginner = this.setBeginner;
        for (let i = 0; i < this.currentLeg; i++) {
            if (legBeginner < this.gameSetUpService.teamCount - 1) {
                legBeginner++;
            } else {
                legBeginner = 0;
            }
        }
        this.legBeginner = legBeginner;



        for (let i = 0; i < this.teams.length; i++) {
            if (this.teams[i].sets[this.currentSet].legs[this.currentLeg].win) {
                this.teams[i].sets[this.currentSet].legs[this.currentLeg].win = false;
                this.currentTeam = i;
            }
        }
    } */


    /* previousTeam() {
        if (this.currentTeam > 0) {
            this.currentTeam--;
        } else {
            this.currentTeam = this.gameSetUpService.teamCount - 1;

            if (this.gameSetUpService.gameMode === 'count-up') {
                this.currentCountUpRound--;
            }
        }
    } */


    /* editPreviousScore() {
        this.editMode = true;
        this.previousTeam();
        if (this.teams[this.currentTeam].sets[this.currentSet].legs[this.currentLeg].scores.length > 0) {
            this.editScoreValue = this.teams[this.currentTeam].sets[this.currentSet].legs[this.currentLeg].scores[0];
            this.teams[this.currentTeam].sets[this.currentSet].legs[this.currentLeg].scores.splice(0, 1);
        } else {
            if (this.currentLeg > 0) {
                console.log('previous leg');
                this.currentLeg--;
                this.previousLegBeginner();
                this.editScoreValue = this.teams[this.currentTeam].sets[this.currentSet].legs[this.currentLeg].scores[0];
                this.teams[this.currentTeam].sets[this.currentSet].legs[this.currentLeg].scores.splice(0, 1);
            } else {
                if (this.currentSet > 0) {
                    console.log('previous set');
                    this.currentSet--;
                    this.previousSetBeginner();
                    this.editScoreValue = this.teams[this.currentTeam].sets[this.currentSet].legs[this.currentLeg].scores[0];
                    this.teams[this.currentTeam].sets[this.currentSet].legs[this.currentLeg].scores.splice(0, 1);
                } else {
                    console.log('no more scores');
                    this.nextTeam();
                }
            }
        }
    } */


    checkIfTeamHasWon(teamIndex) {

        let hasWon = false;
        let sum = this.teams[teamIndex].sets[this.currentSet].legs[this.currentLeg].scores.reduce(function(pv, cv) { return pv + cv; }, 0);

        let points = this.gameSetUpService.points + this.teams[this.currentTeam].handicap;
        if (this.gameSetUpService.gameMode === 'X01' && sum === points) {
            hasWon = true;
        }

        if (this.gameSetUpService.gameMode === 'count-up' && this.currentCountUpRound + 1 === this.gameSetUpService.countUpRounds && this.currentTeam === this.gameSetUpService.teamCount - 1) {
             hasWon = true;
        }

        return hasWon;
    }


    setWinner() {
        this.teams[this.currentTeam].sets[this.currentSet].legs[this.currentLeg].win = true;
    }


    nextLeg() {
        if (this.currentLeg < this.gameSetUpService.legs - 1 && !this.majorityLegsOfCurrentSet()) {
            this.winnerData = {
                leg: this.currentLeg,
                set: this.currentSet,
                setEnd: false,
                end: false,
            };
            this.showWinner = true;

            this.currentLeg++;
            this.nextLegBeginner();
        }else {
            this.winnerData = {
                leg: this.currentLeg,
                set: this.currentSet,
                setEnd: false,
                end: true,
            };
            this.showWinner = true;

            console.log('game done');
            /* if (this.currentSet < this.gameSetUpService.sets - 1) {
                this.winnerData = {
                    leg: this.currentLeg,
                    set: this.currentSet,
                    setEnd: true,
                    end: false,
                };
                this.showWinner = true;

                this.currentSet++;
                this.currentLeg = 0;
                this.nextSetBeginner();
            } else {
                this.winnerData = {
                    leg: this.currentLeg,
                    set: this.currentSet,
                    setEnd: false,
                    end: true,
                };
                this.showWinner = true;

                console.log('game done');
            } */
        }
    }



    majorityLegsOfCurrentSet() {
        let countWins = 0;

        for (let i = 0; i < this.teams[this.currentTeam].sets[this.currentSet].legs.length; i++) {
            if (this.teams[this.currentTeam].sets[this.currentSet].legs[i].win) {
                countWins++;
            }
        }

        if (countWins / this.gameSetUpService.legs > 0.5) {
            return true;
        } else {
            return false;
        }
    }



    teamQueue() {
        let queue = [];

        for (let i = this.currentTeam; i < this.teams.length; i++) {
            let teamData = this.teams[i];
            teamData.id = i;
            queue.push(teamData);
        }
        for (let i = 0; i < this.currentTeam; i++) {
            let teamData = this.teams[i];
            teamData.id = i;
            queue.push(teamData);
        }

        console.log('queue', queue);
        return queue;

    }



    // calculates how many points are missing till finish (for double-out)
    calcPoints(teamId) {
        return this.teams[teamId].handicap + this.gameSetUpService.points - this.teams[teamId].sets[this.currentSet].legs[this.currentLeg].scores.reduce(function(pv, cv) { return pv + cv; }, 0);
    }


    editScore(event) {
        console.log(event);
        this.editScoreData = event;
        this.editScoreMode = true;
        // event.teamData.scores[event.scoreIndex] = 22;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/game/game.component.ts